import routes from '@/modules/decision-purpose/decision-purpose-routes';
import store from '@/modules/decision-purpose/decision-purpose-store';

export default {
    routes,
    store,
}
